import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "transactions" };
const _hoisted_2 = { class: "transactions-container" };
const _hoisted_3 = { class: "moneyIn" };
const _hoisted_4 = { class: "text-caption" };
import { ref, watch } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useVouchers } from '@/composables/useVouchers';
import SwipeActionsContainer from './SwipeActionsContainer.vue';
import MGButton from './MGButton.vue';
import MGDialog from './MGDialog.vue';
let hasShownPreview = false;
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherTransactionsList',
    props: {
        search: { type: Boolean },
        localVoucher: {}
    },
    emits: ["transactionDeleted", "transactionUpdated"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useAppState();
        useAuth();
        const { deleteVoucherTransaction, updateVoucherTransaction } = useVouchers();
        const showPreview = !hasShownPreview;
        hasShownPreview = true;
        const currentVoucher = ref(props.localVoucher);
        const showEditModal = ref(false);
        const editAmount = ref('');
        const editingTransaction = ref(null);
        const rules = {
            required: (value) => !!value || 'Amount is required',
            positive: (value) => value > 0 || 'Amount must be positive',
            maxBalance: (value) => {
                if (!value)
                    return true;
                const currentBalance = props.localVoucher.currentBalance;
                const oldAmount = editingTransaction.value?.amount || 0;
                const newAmount = parseFloat(value);
                const availableBalance = currentBalance + oldAmount;
                return newAmount <= availableBalance || 'Invalid amount';
            }
        };
        watch(() => props.localVoucher, (newVoucher) => {
            currentVoucher.value = newVoucher;
        }, { immediate: true });
        function formattedTransactionDate(createdDateTime) {
            const date = new Date(createdDateTime);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('default', { month: 'long' });
            const year = date.getFullYear();
            return `${day} ${month}, ${year}`;
        }
        function preventNegative(event) {
            if (event.key === '-' || event.key === 'e') {
                event.preventDefault();
            }
        }
        function deleteTransaction(voucher, transaction) {
            deleteVoucherTransaction(voucher.id, transaction.id, () => {
                emit('transactionDeleted', transaction);
            });
        }
        function handleSwipeAction({ item: transaction, action }) {
            if (action.type === 'delete') {
                deleteTransaction(currentVoucher.value, transaction);
            }
            else if (action.type === 'edit') {
                openEditModal(transaction);
            }
        }
        function openEditModal(transaction) {
            editingTransaction.value = transaction;
            editAmount.value = transaction.amount.toString();
            showEditModal.value = true;
        }
        function cancelEdit() {
            showEditModal.value = false;
            editAmount.value = '';
            editingTransaction.value = null;
        }
        function saveEdit() {
            if (!editAmount.value || editAmount.value <= 0) {
                return;
            }
            const oldAmount = editingTransaction.value?.amount || 0;
            const newAmount = parseFloat(editAmount.value);
            const transaction = editingTransaction.value;
            updateVoucherTransaction(currentVoucher.value.id, transaction.id, newAmount, () => {
                transaction.amount = newAmount;
                cancelEdit();
                emit('transactionUpdated', transaction, newAmount, oldAmount);
            });
        }
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", {
                onClick: _cache[3] || (_cache[3] = event => { event.stopPropagation(); })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_divider, { class: "mt-2" }),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(SwipeActionsContainer, {
                            items: _ctx.localVoucher.customerVoucherTransactions,
                            preview: showPreview,
                            actions: [
                                {
                                    icon: 'mdi-delete',
                                    type: 'delete',
                                    color: 'white',
                                    backgroundColor: 'var(--background-color-alt2)'
                                },
                                {
                                    icon: 'mdi-pencil',
                                    type: 'edit',
                                    backgroundColor: 'var(--background-color-alt)'
                                }
                            ],
                            onActionClick: handleSwipeAction
                        }, {
                            default: _withCtx(({ item: transaction }) => [
                                _createVNode(_component_v_row, { class: "transaction-row" }, {
                                    default: _withCtx(() => [
                                        (transaction.createdDateTimeString != _unref(state).today && transaction.createdDateTimeString != _unref(state).yesterday)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                class: "date-col"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(formattedTransactionDate(transaction.createdDateTime)), 1)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true),
                                        (transaction.createdDateTimeString == _unref(state).today)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 1,
                                                class: "date-col"
                                            }, {
                                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                    _createTextVNode("Today")
                                                ])),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        (transaction.createdDateTimeString == _unref(state).yesterday)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 2,
                                                class: "date-col"
                                            }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                    _createTextVNode("Yesterday")
                                                ])),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, { class: "amount-col" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_unref(state).formatter.format(transaction.amount)), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 1
                        }, 8, ["items"]),
                        _createVNode(_component_v_divider, { class: "mt-5" }),
                        _createVNode(_component_v_row, { class: "transaction-row" }, {
                            default: _withCtx(() => [
                                (_ctx.localVoucher.createdDateTimeString != _unref(state).today && _ctx.localVoucher.createdDateTimeString != _unref(state).yesterday)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: "date-col"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(formattedTransactionDate(_ctx.localVoucher.createdDateTime)), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (_ctx.localVoucher.createdDateTimeString == _unref(state).today)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        class: "date-col"
                                    }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("Today")
                                        ])),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (_ctx.localVoucher.createdDateTimeString == _unref(state).yesterday)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        class: "date-col"
                                    }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("Yesterday")
                                        ])),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { class: "amount-col" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, "+" + _toDisplayString(_unref(state).formatter.format(_ctx.localVoucher.faceValue)), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _createVNode(MGDialog, {
                    modelValue: showEditModal.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showEditModal).value = $event)),
                    "max-width": "400px",
                    title: "Enter the amount redeemed",
                    "content-height": "150px"
                }, {
                    content: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "mgTextField",
                            modelValue: editAmount.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editAmount).value = $event)),
                            label: "New Amount",
                            type: "text",
                            inputmode: "decimal",
                            rules: [rules.required, rules.positive, rules.maxBalance],
                            autofocus: "",
                            prefix: "£",
                            variant: "solo",
                            flat: true,
                            clearable: "",
                            "single-line": "",
                            "bg-color": "white",
                            onKeydown: _cache[1] || (_cache[1] = ($event) => (preventNegative($event)))
                        }, null, 8, ["modelValue", "rules"]),
                        _createElementVNode("div", _hoisted_4, " Current amount: " + _toDisplayString(_unref(state).formatter.format(editingTransaction.value?.amount || 0)), 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            class: "button-row",
                            text: "Save",
                            onClick: saveEdit,
                            disabled: !editAmount.value || editAmount.value <= 0
                        }, null, 8, ["disabled"]),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            class: "button-row",
                            outline: true,
                            text: "Cancel",
                            onClick: cancelEdit
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
